// useScreenSize.js
import { useState, useEffect } from 'react';

const useMobileScreen = () => {
  const [screenSize, setScreenSize] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
        setScreenSize(window.innerWidth <= 768); 
      };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenSize;
};

export default useMobileScreen;